/** Derive display metadata for attachment object keys returned by the list/detail API (no size/type stored). */
export function guessMimeTypeFromFileName(fileName: string): string {
	const ext = fileName.split(".").pop()?.toLowerCase() ?? "";
	const map: Record<string, string> = {
		pdf: "application/pdf",
		png: "image/png",
		jpg: "image/jpeg",
		jpeg: "image/jpeg",
		gif: "image/gif",
		webp: "image/webp",
		doc: "application/msword",
		docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		xls: "application/vnd.ms-excel",
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	};
	return map[ext] ?? "application/octet-stream";
}

export function displayNameFromObjectKey(objectKey: string): string {
	const segment = objectKey.includes("/") ? objectKey.split("/").pop() ?? objectKey : objectKey;
	return segment.trim() || objectKey;
}

export function buildFileInfosFromObjectKeys(objectKeys: string[]) {
	return objectKeys
		.filter((k): k is string => typeof k === "string" && Boolean(k.trim()))
		.map(objectKey => {
			const name = displayNameFromObjectKey(objectKey);
			return {
				objectKey,
				name,
				size: 0,
				type: guessMimeTypeFromFileName(name),
			};
		});
}

export type AttachmentFileInfo = {
	objectKey: string;
	name: string;
	size: number;
	type: string;
};

/** Keep metadata for keys still present; synthesize rows for any new keys. */
export function mergeFileInfosForKeys(keys: string[], previous: AttachmentFileInfo[]): AttachmentFileInfo[] {
	const byKey = new Map(previous.map(f => [f.objectKey, f]));
	return keys.map(k => byKey.get(k) ?? buildFileInfosFromObjectKeys([k])[0]);
}
